__turbopack_context__.v({
  "intro": "intro-module-scss-module__q4Ghjq__intro",
  "introDescription": "intro-module-scss-module__q4Ghjq__introDescription",
});
